/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Soft_Deer_LeapInputs */

const en_bright_soft_deer_leap = /** @type {(inputs: Bright_Soft_Deer_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segments`)
};

const de_bright_soft_deer_leap = /** @type {(inputs: Bright_Soft_Deer_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmente`)
};

/**
* | output |
* | --- |
* | "Segments" |
*
* @param {Bright_Soft_Deer_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_soft_deer_leap = /** @type {((inputs?: Bright_Soft_Deer_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Soft_Deer_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_soft_deer_leap(inputs)
	return de_bright_soft_deer_leap(inputs)
});